import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { CommonService } from 'src/app/shared/common.service';
import { environment } from 'src/environments/environment';
import { ErrorMessageService } from '../services/error-message.service';
import { SKIP_ERROR_TOAST } from '../http/error-toast.token';
import { durationFor, severityFor } from '../http/error-presentation';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private commonService: CommonService,
    private errorMessages: ErrorMessageService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Only handle our own API; let other errors propagate untouched.
        if (!request.url.startsWith(environment.BASE_URL)) {
          return throwError(() => error);
        }

        // The caller opted to handle this failure itself (avoids double toast).
        if (request.context.get(SKIP_ERROR_TOAST)) {
          return throwError(() => error);
        }

        const appError = this.errorMessages.parse(error);

        console.warn('API Error', {
          url: request.url,
          status: appError.status,
          code: appError.code,
        });

        this.commonService.showToast(appError.messages, severityFor(appError), {
          duration: durationFor(appError),
        });

        return throwError(() => error);
      })
    );
  }
}
